export const dataLayerPush = (e, eventElement = null, category = null, action = null, label = null) => {
    const dataLayer = global.dataLayer;
    const text = e.currentTarget.textContent;
    const event = eventElement ? eventElement : 'CTA Button'
    const eventAction = action ? action : text;
    const eventCategory = category ? category : 'Button';
    const eventLabel = label ? label : global.location.pathname;
    const pushObject = {
        event,
        eventCategory,
        eventAction,
        eventLabel
    }
    //console.log(pushObject);
    dataLayer.push(pushObject);
}

export const containsSubdomain = (subdomain) => {
    if (typeof window === 'undefined') { return; }
    const currentUrl = window.location.hostname;
    const regex = new RegExp(`^${subdomain}\\.`);
    return regex.test(currentUrl);
};

export const getDomainFromHref = (href) => {
    if (href !== '#' || href.contains('javascript')) {
        const url = new URL(href);
        return url.hostname;
    }
    return undefined;
}

export const toPascalCase = (str) => {
    if (!str) return "";

    return str
        .split(/\s+/)              // split on spaces
        .filter(Boolean)           // remove empty strings
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join("");
};

export const buildWidenPreviewImageFromVideoUrl = (url, keys = [
    'original',
    'mp4'
]) => {
    try {
        const parsed = new URL(url);
        const parts = parsed.pathname.split('/');

        // find index of the first matching key
        const index = parts.findIndex(p => keys.includes(p));

        if (index === -1) {
            // no matching key found → return original
            return url;
        }

        // rebuild path up to the key, replace it with 'jpeg'
        const newPath = [...parts.slice(0, index), 'jpeg'].join('/');

        return `${parsed.origin}${newPath}`;
    } catch (e) {
        console.error('Invalid URL:', url);
        return url;
    }
};


// WEBPACK FOOTER //
// ./src/utils/index.js